import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * The shadcn/ui class helper. `clsx` resolves conditionals; `twMerge` resolves Tailwind
 * conflicts so a later `p-6` beats an earlier `p-4` instead of both landing in the
 * class list and the cascade deciding by declaration order.
 */
export const cn = (...inputs: ClassValue[]): string => twMerge(clsx(inputs));
